goog.provide('el8.uiwidget.FormDialog');

goog.require('el8.model.base');
goog.require('el8.uiwidget.NewDialog');


/**
 * This is a subclass of NewDialog that represents a dialog with a Form in it. We expect that it
 * will have buttons at the bottom of the dialog (for saving/canceling, e.g.).  We use them all
 * over the place.
 *
 * See Form.js for more detail on the field spec that you will need to create to setup a form in
 * your dialog.
 *
 * See editReportDetails.js (and appchart.dialog.editReportDetails.html) for an example usage.
 *
 * IMPORTANT: make sure to goog.require('el8.uiwidget.Form') in the caller since you'll be
 * instantiating a Form and passing it in. Not doing so can break the minified JS if your form
 * dialog JS happens to be placed before the definition of Form in the minified file.
 */
el8.uiwidget.FormDialog = function(spec) {

    spec = spec || {};

    /**
     * @type {el8.uiwidget.Form}
     */
    this._form = spec.form || null;

    el8.uiwidget.NewDialog.apply(this, arguments);
};
el8.uiwidget.FormDialog.inheritsFrom(el8.uiwidget.NewDialog);

el8.uiwidget.FormDialog.prototype.setForm = function(form) {
    if (!form) { return this; }
    if (this._form) { // if we had a previous form, make sure to kill its button listeners
        this._form.unbindButtonEvents();
    }

    this._form = form;
    if (this._isInit) { // if already init, need to hook up form to dialog
        this._form.setContainer(this.getContentElt().find('form:first'));
        this._form.setButtonElt(this.getButtonElt());
    }
    return this;
};
el8.uiwidget.FormDialog.prototype.getForm = function() {
    return this._form;
};
el8.uiwidget.FormDialog.prototype.clearForm = function() {
    if (this._form) {
        this._form.unbindButtonEvents();
        this._form = null;
    }
};

el8.uiwidget.FormDialog.prototype._init = function() {
    el8.uiwidget.NewDialog.prototype._init.apply(this, arguments);
    if (this._form) {
        this._form.setContainer(this.getContentElt().find('form:first'));
        this._form.setButtonElt(this.getButtonElt());
    }
};

el8.uiwidget.FormDialog.prototype.show = function() {
    el8.uiwidget.NewDialog.prototype.show.apply(this, arguments);
    if (this._form) { 
        this._form.render(); 
    }
    this.adjustHeight(); /* unfortunately, this is called twice */
};

el8.uiwidget.FormDialog.prototype.hide = function() {
    if (this._form) { 
        this._form.reset();
        this._form.disable();
    }
    el8.uiwidget.NewDialog.prototype.hide.apply(this, arguments);
};

el8.uiwidget.FormDialog.prototype.hideEmptyFields = function() {
    var form = this.getForm();
    var fieldNames = form.getFieldNames();
    for (var i=0, numFields=fieldNames.length; i<numFields; i++) {
        if (form.getVal(fieldNames[i]) === '') {
            form.hideField(fieldNames[i]);
        }
    }
    this.adjustHeight();
};

el8.uiwidget.FormDialog.prototype.showAllFields = function() {
    var form = this.getForm();
    var fieldNames = form.getFieldNames();
    for (var i=0, numFields=fieldNames.length; i<numFields; i++) {
        form.showField(fieldNames[i]);
    }
    this.adjustHeight();
};
